import React, { FC, useContext, useState } from 'react'
import { AppStateContext } from '@components/layouts/DynamicLayout'
import Modal from '@components/ui/modal'
import Loader from '@components/ui/loader'
import { Formik } from 'formik'
import Text from '@components/ui/text'
import { RepereIntegrationRepository } from '@services/repositories/_miscellaneous.repository'
import { Request } from '@services/models'

type Props = {
	isOpen: boolean
	request?: Request
	title?: string
	description?: string
	isDefaultCancelReason?: boolean
	isHomePage?: boolean
	onCancel: () => void
}

const CancelRequestModal: FC<Props> = ({
	isOpen,
	request,
	onCancel,
	title,
	description
}) => {
	const { pageData } = useContext(AppStateContext)
	const [loading, setLoading] = useState(false)
	const repereRepo = new RepereIntegrationRepository()

	const handleCancelRequest = async () => {
		if (!request) return
		try {
			setLoading(true)
			await repereRepo.cancelRequest({
				requestId: request.code,
				requestGuid: request.id ? request.id : ''
			})
		} catch (err) {
			console.error(err)
		} finally {
			setTimeout(() => {
				window.location.reload()
				onCancel()
				setLoading(false)
			}, 5)
		}
	}

	return (
		<Modal
			title={title ?? `Annulation de la requête ${request?.code ?? ''}`}
			primaryButtonText={"Confirmer l'annulation"}
			cancelButtonText={pageData?.assets?.cancel}
			showExitBtn
			isOpen={isOpen}
			onCancelBtn={onCancel}
			onPrimaryButton={() => {
				document.getElementById('cancel-request-submit')?.click()
			}}
			onSetIsOpen={() => {}}
			lessPadding
		>
			{loading ? (
				<Loader text={pageData?.assets?.loading} />
			) : (
				<Formik
					initialValues={{
						motif: ''
					}}
					onSubmit={() => void handleCancelRequest()}
					style={{ padding: '10px' }}
				>
					{({ handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							{description && (
								<div style={{ paddingRight: 25, marginTop: -5 }}>
									<Text content={description + request?.code + '.'} />
								</div>
							)}

							<button
								id="cancel-request-submit"
								type="submit"
								style={{ display: 'none' }}
								aria-hidden
							/>
						</form>
					)}
				</Formik>
			)}
		</Modal>
	)
}

export default CancelRequestModal
